import React, { useState } from "react"
import { connect } from "react-redux"
import { AutoComplete } from "antd"
import _ from "../../utils/lodashUtils"
import "./RestaurantAutoSuggest.scss"
import {
  renderCuisines,
  renderDollars,
  stars,
  isClosedRestaurant,
} from "../../utils/helpers"
import { TextTag as Text } from "../../atoms"
import { SEARCHBAR_PLACEHOLDER, ESTTIME } from "../../constants/messages"
import MiniSearch from "minisearch"
import { SearchBar } from "../../atoms"

const { Option } = AutoComplete

const AutoCompleteRestaurants = (props) => {
  const [value, setValue] = useState("")
  const { setRestaurantList, restaurantList, restaurants } = props

  const handleSearch = async (value) => {
    setValue(value)
    if (_.isEmpty(value)) {
      // Return the entire list when the value is empty string
      setRestaurantList(Object.values(restaurants))
      return
    }
    let filteredRes = []

    let miniSearch = new MiniSearch({
      fields: ["name", "cuisines", "specials"],
      extractField: (document, fieldName) => {
        // Specials contains nested strucutres
        if (fieldName === "specials") {
          const specials = document["specials"]
          // Use name attribute for specials search
          const _specialNames = specials.map((x) => {
            return x.name
          })
          return _specialNames.join(" ")
        }
        const value = document[fieldName]
        // If field value is an array, join it by space
        return Array.isArray(value) ? value.join(" ") : value
      },
    })
    miniSearch.addAll(Object.values(restaurants))

    //fuzzy to 0.2 i.e incorrect spelling
    //the search can be broadened in the future
    const filteredResturantIds = miniSearch.search(value, {
      fuzzy: 0.2,
    })

    //push the searched results to an array using id
    !_.isEmpty(filteredResturantIds) &&
      filteredResturantIds.forEach((res) => {
        filteredRes.push(restaurants[res.id])
      })

    setRestaurantList(filteredRes)
  }

  const selectRestaurant = (current) => async () => {
    const flteredRestr = Object.values(restaurants).filter(
      (res) => res.id == current.id
    )
    setRestaurantList(flteredRestr)
  }

  const handleSelect = (selectedValue) => {
    const restaurantData = restaurants[selectedValue]
    setValue(restaurantData.name)
    selectRestaurant(restaurantData)()
  }

  let children = []
  !_.isEmpty(restaurantList) &&
    restaurantList.forEach((restaurant) => {
      const orderTime = _.get(restaurant, "order_time", {})
      const isOpen = orderTime.open && orderTime.delivery
      const etaText = `~${restaurant.availability["delivery_estimate"]} min`
      // disable restaurants in suggests which are not open for delivery
      children.push(
        <Option key={restaurant.id} value={restaurant.id.toString()}>
          <section className="restaurant">
            <div className="menu-dropdown">
              <div className="left-part">
                {/* ****if close functionality required in future uncomment it *****

              <div className="image-container">
                {isClosedRestaurant(restaurant) ? (
                  <div className="restaurant-closed">
                    <Text textType="smallTextPrimary">
                      Closed
                  </Text>
                  </div>
                ): <div className="restaurant-open">
                  <Text textType="smallTextPrimary">
                      Open
                  </Text>
                  </div>}
              </div> */}

                <div className="restaurant-details">
                  <div className="restaurant-name">{restaurant.name}</div>
                  <div className="cuisine-container">
                    <Text textType="smallTextPrimary">
                      {renderCuisines(restaurant)}
                    </Text>
                  </div>
                  <div className="restaurant-rating">{stars(restaurant)}</div>
                </div>
              </div>
              <div className="restaurant-eta">
                <div>{renderDollars(restaurant)}</div>
                <div className="eta-min">{ESTTIME(etaText)}</div>
              </div>
            </div>
            <div className="separator-line"></div>
          </section>
        </Option>
      )
    })

  return (
    <SearchBar
      onSearch={handleSearch}
      placeholder={SEARCHBAR_PLACEHOLDER}
      onSelect={handleSelect}
      value={value}
    >
      {children}
    </SearchBar>
  )
}

const mapStateToProps = (state) => {
  return {
    restaurants: state.planDinner.restaurants,
    user: state.auth.user,
  }
}

export default connect(mapStateToProps)(AutoCompleteRestaurants)
